import CreateAccount from "@affinity/Handlers/CreateAccount";
import { CustomState } from "@affinity/Store/Reducers";
import Button from "@insite/mobius/Button";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    // Map required state elements to component properties
});

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const Step7Payment: React.FC<Props> = ({ 
}) => {
    function submit() {
    }

    return (
        <div><Button onClick={() => submit()}>Submit</Button></div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Step7Payment);